import { RootState } from "@/store/store";
import { billingExplorerSavingsOpportunitiesTotalMonthlySavingsEndpointSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/savings-opportunities/billingExplorerSavingsOpportunitiesTotalMonthlySavingsEndpointSelector";

export const billingExplorerTotalMonthlySavingsSelector = (
  state: RootState,
) => {
  return billingExplorerSavingsOpportunitiesTotalMonthlySavingsEndpointSelector(
    state,
  )?.data;
};
